import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function card(theme: Theme): ComponentStyle {
  return {
    componentName: 'card',
    baseStyle: {
      backgroundColor: theme.colors.onSurface,
      borderRadius: theme.sizes[-3],
      flex: '1'
    },
    variants: {
      table: {
        padding: 0
      },
      chartKpiCard: {
        padding: `${theme.space['xs']} ${theme.space['s']}`
      }
    }
  };
}
